import moment from 'moment';
import { defaultChartColors } from '../../helpers/defaultChartColors';

export const getDefaultOptions = (isChartExpanded: boolean, maxShownColumns: number) => ({
  color: defaultChartColors,
  dataZoom: isChartExpanded
    ? [
        {
          type: 'slider',
          maxValueSpan: maxShownColumns - 1,
          bottom: 50,
          labelFormatter: function (value: string, valueStr: string) {
            return moment(valueStr).format("MMM'YY");
          },
        },
      ]
    : null,
  grid: {
    left: 66,
    top: 16,
    right: 26,
    bottom: isChartExpanded ? 110 : 65,
  },
  xAxis: {
    type: 'category',
    axisTick: {
      show: false,
    },
    axisLabel: {
      interval: 0,
      formatter: (value: string) => moment(value).format("MMM'YY"),
    },
    axisPointer: {
      type: 'none',
    },
  },
});
